<mat-dialog-content
  class="add-channel-dialog"
  fxLayout="column"
>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="dialog-header"
  >
    <div class="title">Create New</div>
    <div>
      <button
        mat-icon-button
        type="button"
        class="close-button"
        aria-label="Close dialog"
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div fxLayout="column" fxLayoutGap="20px">
    <form
      [formGroup]="form"
      fxLayout="row"
      fxLayout.lt-md="column"
      fxLayoutAlign="space-between start"
      fxLayoutAlign.lt-md="start"
      fxLayoutGap="2%"
    >
      <mat-form-field appearance="outline" style="width: 100%">
        <input
          type="text"
          formControlName="searchBy"
          matInput
          placeholder="Enter User Name or Eid*"
          id="searchBy"
          [matAutocomplete]="auto"
          required
        />
        <mat-autocomplete autoActiveFirstOption="true" #auto="matAutocomplete">
          @for (user of filteredUsers; track user.eid) {
            <mat-option
              [value]="user.name + ' (' + user.eid  +')'"
              (onSelectionChange)="createChannel(user)"
            >
              {{ user.name }} ({{ user.eid }})
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    fxLayoutGap="16px"
    class="form-footer"
  >
    <button
      id="submit"
      mat-raised-button
      color="primary"
      class="btn field-height-button"
      type="button"
      (click)="onSubmit()"
      [disabled]="validateForm()"
    >
      Create
    </button>
    <button
      id="cancel"
      mat-stroked-button
      class="btn btn-outline-accent field-height-button"
      type="button"
      (click)="closeDialog()"
    >
      Cancel
    </button>
  </div>

</mat-dialog-content>
